import { ApiSchemas } from '..'
import { client } from '../client'
import { wrapEndpoint } from '../wrap'


export default {
  async generateSummary(id: number) {
    return wrapEndpoint(() =>
      client.PATCH('/legacy-attendance/{id}/generate-summary', {
        params: {
          path: {
            id,
          },
        },
      }),
    )
  },
}
